// Cómo entra una línea al carrito de la tienda online. Es la regla de la portada
// (`RestaurantMicrosite.handleAddToCart`), compartida con las páginas de pasillo y de
// producto del súper (`useGroceryCart().add`) para que las tres agreguen igual.
import type { CartItem } from "@/components/microsite/types"

/**
 * Agrega `line` al final, como línea NUEVA. La tienda no suma cantidades: cada
 * «Agregar» es una línea y la cantidad se cambia en el carrito (`CartStep`).
 */
export function appendCartLine(cart: CartItem[], line: CartItem): CartItem[] {
  return [...cart, line]
}
